import useAppConfig from "../../hooks/useAppConfig"
import useAuth from "../../hooks/useAuth"

const useSchemeBusiness = () => {
  const pwaConfig = useAppConfig()
  const { user } = useAuth()
  return pwaConfig?.appConfig?.selecteBussines?.name || user?.business
}

export default useSchemeBusiness
